export default {
    app_name: import.meta.env.VITE_APP_SITE_NAME,
    shopping_agent: 'Agent d\'achat',
    forwarding: 'Expédition',
    services: 'Services',
    about: 'À propos',
    expert_buy: 'Achat expert',
    shipping_calculator: 'Calculateur d\'expédition',
    customer_review: 'Avis clients',
    dropshipping: 'Dropshipping',
    business_service: 'Service professionnel',
    trusted_seller: 'Vendeurs certifiés',
    blog: 'Blog',
    user_guides: 'Guides utilisateur',
    terms_of_service: 'Conditions d\'utilisation',
    terms_of_shipping: 'Conditions d\'expédition',
    privacy_policy: 'Politique de confidentialité',
    faq: 'FAQ',
    home: 'Accueil',
    notice: 'Avis',
    cart: 'Panier',
    me: 'Mon compte',
    service_menu: 'Menu des services',
    account: 'Compte',
    user_center: 'Centre utilisateur',
    my_order: 'Mes commandes',
    my_store: 'Ma boutique',
    log_out: 'Déconnexion',
    sign_in: 'Connexion',
    sign_up: 'Inscription',
    compensation_taxation: 'Compensation et taxation',
    tok_forum: 'Forum',
    get_community_help: 'Rejoignez notre forum',
    community_des: 'Rejoignez notre forum pour obtenir de l\'aide et aider les autres',
    page_home: {
        title: 'Votre destination ultime',
        description: 'Agent d’achat chinois',
        search_product_text: 'URL du produit',
        timeline: [
            {
                title: "Passez commande",
                subtitle: "Sélection et achat"
            },
            {
                title: "Soumettez les colis",
                subtitle: "Contrôle qualité et expédition internationale"
            },
            {
                title: "Réception",
                subtitle: "Recevez et partagez"
            }
        ],
        cards: [
            ["Inscrivez-vous", "et recevez un coupon de 350$ !"],
            ["Guide", "du débutant"],
            ["Rejoignez-nous", "sur Reddit & Discord"]
        ],
        shop_chinese: {
            title: "Achetez sur les sites e-commerce chinois",
            cards: [
                {
                    title: "Passer vos commandes",
                    description: "Profitez d’un shopping sans tracas pour tout produit provenant de Chine, disponible en ligne ou hors ligne. Pour passer commande, collez simplement le lien du produit. Profitez de notre service complet, de la recherche à l’achat, en toute simplicité."
                },
                {
                    title: "Livraison à l'entrepôt NiuniuBox",
                    description: "Achetez auprès de différents vendeurs via notre service, et nous regrouperons efficacement vos achats. Tous les articles seront expédiés à l'entrepôt NiuniuBox en Chine, simplifiant ainsi le processus pour vous."
                },
                {
                    title: "Contrôle qualité",
                    description: "Une fois vos produits arrivés à l'entrepôt NiuniuBox, ils subissent un contrôle qualité rigoureux. Notre équipe vérifie minutieusement chaque article pour détecter tout défaut et garantir la conformité en taille, couleur, etc. Avec NiuniuBox, soyez serein grâce à notre service après-vente dédié."
                },
                {
                    title: "Expédition internationale",
                    description: "Choisissez les produits de votre inventaire en entrepôt et regroupez-les facilement en un seul colis. Grâce aux services d’expédition internationale fiables de NiuniuBox, vos achats sont livrés directement chez vous. Profitez de la commodité d’un service d’expédition de classe mondiale."
                }
            ]
        },
        bottom: [
            {
                title: "Produits en abondance",
                description: "Nous trouvons pour vous des produits variés et économiques en provenance de Chine"
            },
            {
                title: "Coût réduit",
                description: "Un seul coût d’expédition pour des produits de différents vendeurs, tous regroupés en un seul colis"
            },
            {
                title: "Service de qualité",
                description: "Nous valorisons votre fidélité et visons à offrir un service et un accompagnement exceptionnels"
            },
            {
                title: "Réponse rapide",
                description: "Réponse garantie à toutes vos questions concernant notre service"
            }
        ],
        migration: {
            title: "Annonce importante",
            dear_users: "Chers utilisateurs,",
            announce_before_link:
                "Nous avons le plaisir d’annoncer que Niuniubox a officiellement été renommé Pikobuy ",
            link_label: "www.pikobuy.com",
            closing:
                "Nous continuerons à vous offrir notre service dévoué sous notre nouvelle marque.",
            got_it: "Compris",
        },
    },
    page_shopping: {
        shopping_des: 'Acheter depuis la Chine',
        shopping_step: '1.Trouver & Rechercher un produit 2.Payer les articles 3.Nous achetons pour vous 4.Payer l\'expédition 5.Nous expédions pour vous',
        category: 'Catégorie',
        load_more_items: 'Charger plus d\'articles',
        note: 'Avertissement : Tous les produits disponibles pour notre service d\'agent d\'achat affichés sur notre site proviennent de plateformes d\'achat tierces et ne sont pas vendus directement par nous. Ainsi, nous ne sommes pas responsables des problèmes causés par la violation des droits de propriété intellectuelle ou des droits d\'auteur des marchandises.',
        bottom_text: 'En tant qu\'agent Taobao professionnel, nous vous aidons à acheter de nombreux produits à des prix très bas sur les plus grands sites d\'achat chinois. Nous sommes votre agent Taobao pour trouver, acheter, inspecter et livrer des articles depuis Taobao.com, 1688.com. Notre devis inclut l\'approvisionnement en Chine, l\'achat et l\'expédition internationale. Nous proposons les plus grandes remises pour l\'expédition internationale depuis la Chine vers tous les pays, y compris les États-Unis, le Canada, le Royaume-Uni, l\'Australie, la France, Singapour, le Mexique, le Brésil, le Chili, etc. Où que vous soyez, nous livrons les colis directement à votre porte. Nous fournissons des informations de suivi en ligne pour tous les envois. Nous avons des gestionnaires de service client professionnels pour vous aider à acheter et expédier avec succès.',
        process_data: 'Traiter les données',
        process_des: 'Vous pouvez tout savoir sur votre commande. Chaque fois que vous vous inquiétez, nous avons des données pour tout vous dire.',
    },
    // ... (les autres sections continuent avec la même structure de traduction)
    // Je peux continuer avec les autres sections si nécessaire

    meta: {
        index_title: 'Agent Taobao | Agent Tmall | Agent 1688 | Taobao en anglais | Agent d\'achat | Transitaire Chine',
        index_des: 'Nous sommes une plateforme d\'agent d\'achat chinoise. Nous aidons les clients à acheter des produits sur Taobao. Acheter vos articles préférés depuis la Chine n\'a jamais été aussi pratique et facile.',
        shopping_agent_title: 'Agent d\'achat',
        shopping_agent_des: 'Achetez des produits chinois avec un agent d\'achat. Agent Taobao, agent 1688, agent Weidian, agent Yupoo.',
        forwarding_title: 'Agent d\'expédition - Expédiez votre colis depuis la Chine',
        forwarding_des: 'Plateforme de transbordement mondiale professionnelle, avec entrepôts de transbordement et fournissant des services logistiques professionnels vers les États-Unis, le Royaume-Uni, le Canada, l\'Allemagne, l\'Australie, Singapour, le Mexique et d\'autres pays, expédition mondiale',
        expert_buy_title: 'Achat expert',
        expert_buy_des: 'Achetez des produits via un agent Taobao, importez de Chine. Prix d\'expédition les plus bas. Pas de frais de service.',
        calculator_title: 'Estimation des frais de logistique internationale',
        calculator_des: 'Nous vous aidons à estimer les coûts logistiques mondiaux. Service logistique abordable. Service logistique plus rapide.',
        trusted_seller_title: 'Vendeurs certifiés',
        trusted_seller_des: 'Vendeurs certifiés : Achetez auprès de ces vendeurs, puis nous vous expédions. Vendeurs Taobao, vendeurs Weidian.',
    },

    "my_parcel": {
        "internationalParcels": "Colis internationaux",
        "trackYourInternationalShipments": "Suivez vos envois internationaux et configurez les préférences d'expédition",
        "pleaseSelect": "Veuillez sélectionner",
        "yourRemark": "Votre remarque",
        "startDate": "Date de début",
        "endDate": "Date de fin",
        "alertTrackParcels": "Suivez vos colis ici. Les colis dont le statut est ‘Prêt pour la configuration d'expédition’ ont été emballés et mesurés, et sont prêts à être configurés pour l'expédition.",
        "noPackagesToShip": "Vous n'avez aucun colis à expédier",
        "parcel": "Colis",
        "parcelID": "ID du colis :",
        "shippingLabel": "Frais d'expédition :",
        "pending": "en attente",
        "finalFee": "Frais finaux :",
        "discount": "Remise :",
        "coupon": "Coupon :",
        "created": "Créé le :",
        "status": "Statut",
        "shippingMethod": "Mode d'expédition",
        "notConfiguredYet": "Non configuré",
        "products": "produit(s)",
        "measured": "Mesuré",
        "estimated": "Estimé",
        "dimensions": "Dimensions :",
        "weightInformation": "Informations sur le poids",
        "billingWeight": "Poids facturable :",
        "na": "N/A",
        "actual": "Réel :",
        "volume": "Volume :",
        "action": "Action",
        "configureShippingMethod": "Mode d'expédition",
        "payShipping": "Payer l'expédition",
        "track": "Suivre",
        "address": "Adresse",
        "shipping": "Expédition :",
        "configure": "Configurer",
        "pay": "Payer",
        "viewMoreProducts": "Voir plus de produits dans ce colis",
        "orderID": "ID de commande :",
        "quantity": "Quantité :",
        "times": "x",
        "addressLabel": "Adresse",
        "yourRemarkTitle": "Votre remarque",
        "parcelRemarkTitle": "Remarque sur le colis",
        "noRemarks": "Aucune remarque pour ce colis",
        "parcelImages": "Images du colis",
        "failedToLoad": "Échec du chargement",
        "noImages": "Aucune image disponible pour ce colis",
        "productsInParcel": "Produits dans le colis",
        "type": "Type :",
        "noProducts": "Aucun détail de produit disponible pour ce colis",
        "configureShipping": "Configurer l'expédition",
        "alertPackagePrepared": "Votre colis a été préparé. Sélectionnez maintenant votre mode d'expédition et fournissez votre adresse de livraison.",
        "packageDetails": "Détails du colis",
        "readyForShipping": "Prêt pour l'expédition",
        "actualWeight": "Poids réel :",
        "actualDimensions": "Dimensions réelles :",
        "packagingNotes": "Notes d'emballage :",
        "step1SubmitAddress": "Étape 1 : Soumettre l'adresse",
        "select": "Sélectionner",
        "recipientName": "Nom du destinataire",
        "email": "E-mail",
        "phoneNumber": "Numéro de téléphone",
        "country": "Pays",
        "city": "Ville",
        "stateProvince": "État/Province",
        "zipCode": "Code postal",
        "selectShippingMethod": "Sélectionner le mode d'expédition",
        "selectCountryFirst": "Sélectionnez d'abord le pays",
        "selectedShippingMethod": "Mode d'expédition sélectionné",
        "estimatedDelivery": "Délai de livraison estimé",
        "estimatedFee": "Frais estimés :",
        "changeShippingMethod": "Changer le mode d'expédition",
        "remark": "Remarque",
        "shippingRemarkPlaceholder": "CPF / CNPJ / ID fiscal / remarque d'expédition",
        "saveAddress": "Enregistrer l'adresse",
        "saveAddressHint": "Enregistrez cette adresse dans votre carnet pour une utilisation future",
        "submitShippingConfiguration": "Soumettre la configuration d'expédition",
        "parcelDetailsTitle": "Détails du colis",
        "statusSection": "Statut",
        "actions": "Actions",
        "parcelDetails": "Détails du colis",
        "trackingInfo": "Informations de suivi",
        "addressInfo": "Informations d'adresse",
        "costDetails": "Détails des coûts",
        "costPending": "en attente",
        "shippingMethodNotConfigured": "Mode d'expédition non configuré",
        "packageDimensions": "Dimensions du colis",
        "measuredDimensions": "Dimensions mesurées",
        "estimatedDimensions": "Dimensions estimées",
        "length": "Longueur :",
        "width": "Largeur :",
        "height": "Hauteur :",
        "totalVolume": "Volume total :",
        "volumetricWeight": "Poids volumétrique :",
        "weightCalculation": "Calcul du poids",
        "weightCalcVolumeUsed": "Poids volumétrique utilisé (supérieur)",
        "weightCalcActualUsed": "Poids réel utilisé (supérieur)",
        "billingWeightTooltip": "C'est le poids utilisé pour la facturation (le plus élevé entre réel et volumétrique)",
        "remarks": "Remarques",
        "noProducts": "Aucun détail de produit disponible pour ce colis",
        "delivery_number": "identifiant du colis"
    },
    footer: {
        supportTitle: "Support",
        "support": [
            "À propos de nous",
            "Contactez-nous",
            "Tarifs des services",
            "Frais de livraison"
        ],
        servicesTitle: "Services",
        "services": [
            "Achats sur Taobao",
            "Agent Yupoo",
            "Agent Weidian",
            "Approvisionnement en produits"
        ],
        tutorialTitle: "Tutoriel",
        "tutorial": [
            "Guide d’achat",
            "Notre blog",
            "Frais de livraison"
        ],
        resourcesTitle: "Ressources",
        "resources": [
            "Politique d’expédition",
            "Remboursement & Retours",
            "Politique de confidentialité",
            "Conditions d’utilisation"
        ],
        followTitle: "Suivez-nous",
        "follow": [
            "Youtube",
            "TikTok",
            "Facebook",
            "Quora",
            "Twitter"
        ],
        "copyright":
            "© 2025 NiuNiuBox - Hong Kong Niuniubox Technology Co., Limited",
        "paymentMethods": [
            "PayPal",
            "American Express",
            "Discover",
            "JCB",
            "Mastercard",
            "VISA"
        ]
    },
    sidebar_titles: ["PROFIL UTILISATEUR", "COMMANDES & LIVRAISON", "FINANCES", "COMPTE"],
    sidebar: [
        "Compte",
        "Commande",
        "Entrepôt",
        "Répétition",
        "Colis",

        "Adresses",
        "Annuler",
        "Historique",
        "Solde",
        "Messages",
        "Coupon",
        "Paramètres",
        "Affiliation"
    ],
    "page_order_history": {
        "title": "Historique des Commandes",
        "search": {
            "order_number_placeholder": "Numéro de Commande",
            "product_name_placeholder": "Nom du Produit",
            "remark_placeholder": "Remarque",
            "style_sku_placeholder": "Style/SKU",
            "start_date_placeholder": "Date de Début",
            "end_date_placeholder": "Date de Fin",
            "status_placeholder": "Veuillez sélectionner"
        },
        "buttons": {
            "search": "Rechercher",
            "pay_shopping_orders": "Payer les Commandes",
            "pay_order": "Payer la Commande",
            "view_order": "Voir la Commande",
            "item_photos": "Photos de l'Article",
            "view_product": "Voir le Produit"
        },
        "table": {
            "empty_text": "Vous n'avez pas encore de commandes.",
            "header": {
                "image": "Image",
                "details": "Détails",
                "product": "Produit",
                "action": "Action"
            },
            "body": {
                "order": "Commande :",
                "total": "Total :",
                "type": "Type :",
                "status": "Statut :",
                "time": "Date :",
                "style": "Style :",
                "quantity": "Quantité :",
                "remark": "Remarque :",
                "name": "Nom :"
            }
        },
        "qc_dialog": {
            "title": "Photos de Contrôle Qualité",
            "notice": "À partir d’août, nous ne fournirons plus de service de photos QC.",
            "empty_description": "Votre article n'est pas encore arrivé à notre entrepôt."
        }
    },

    navbar: {
        "items": ["Estimation d'expédition", "Affiliation", "Contact", "Guide"],
        "cart": "Panier",
        "login": "Connexion",
        "register": "Inscription",
        "logout": "Déconnexion",
        "no": "Non",
        "logout_confirm": "Êtes-vous sûr de vouloir vous déconnecter ?",
        "search": "Recherche",
        "searchPlaceholder": "URL du produit",
        "dropdown": [
            "Centre utilisateur",
            "Message",
            "Commande",
            "En entrepôt",
            "Mes répétitions",
            "Mes colis",
            "Annuler la commande",
            "Déconnexion"
        ],
        me: "Moi",
        home: "Accueil",
        menu: "Menu",
        notice: "Avis",

    },
    page_my_order: {
        product_pic: 'Photo du produit',
        product_qc: 'Photo du contrôle qualité',
        store_order_no: 'Numéro de commande magasin',
        type: 'Type',
        details: 'Voir',
        remark: 'Remarque',
        process: 'Traitement',
        cn_track: 'Suivi CN',
        pay_order: 'Payer la commande',
        search: 'Rechercher',
    },
    page_calculator: {
        des: 'Calculer le prix mondial d\'expédition',
        item_category: 'Catégorie de produit',
        product_weight: 'Poids',
        product_length: 'Longueur',
        product_width: 'Largeur',
        product_height: 'Hauteur',
        check: 'Vérifier maintenant',
        cost_note: 'Remarque : le poids du colis ne doit pas être inférieur à 2,5 KG pour UPS/DHL/FedEx. Sinon, seul l’envoi par Petite Ligne Colis est possible',
        about_service: 'Notre calculateur d\'expédition est une fonctionnalité complémentaire que nous proposons sur notre site dans le cadre de nos services d\'agent d\'achat et de messagerie internationale. En utilisant notre calculateur d\'expédition, vous pouvez estimer les frais d\'expédition approximatifs à payer en fonction des dimensions de vos produits ou colis et de votre pays de destination. Vous pouvez également utiliser notre calculateur pour vérifier les différentes entreprises de transport disponibles vers votre pays de destination, ainsi que leurs délais d\'expédition estimés.',
        service_title: 'À propos du calculateur',
        common_goods: 'Marchandises ordinaires',
        brand_goods: 'Produits de marque',
        liquid_goods: 'Produits liquides',
        battery_goods: 'Produits contenant des batteries',
        shipping_method: 'Méthode d\'expédition',
        delivery_time: 'Délai de livraison',
        warehouse: 'Entrepôt',
        estimated_cost: 'Coût estimé',
        method: 'Méthode',
    },
    page_message: {
        title: 'Message',
        des: 'Vous devez prêter attention à cette partie des nouvelles, car nous vous enverrons un message ou un e-mail.',
    },
    page_cart: {
        title: 'Mon panier',
        item: 'Article',
        product: 'Produit',
        price: 'Prix',
        quantity: 'Quantité',
        freight: 'Fret',
        total: 'Total',
        info: 'Info',
        operate: 'Opérer',
        pay_now: 'Valider',
        confirm_buy: 'Confirmer l\'achat ?',
        yes: 'Oui',
        no: 'Non',
    },
    page_settlement: {
        title: 'Confirmez votre commande',
        information: 'Note',
        note_line1: '1. Prenez des photos du produit gratuitement',
        note_line2: '2. Le montant du paiement inclut le coût des marchandises, les frais de traitement du paiement et les frais de service',
        note_line3: '3. Nous vous informerons de l\'avancement de la commande par e-mail. Veuillez vérifier à temps',
        note_line4: '4. Lorsque vos colis arrivent à l\'entrepôt, vous devez payer les frais d\'expédition',
        note_line5: '5. Vous devez payer des frais supplémentaires pour chaque paiement (PayPal)',
        address_note: 'Veuillez choisir votre pays de destination afin que notre agent d\'achat puisse déterminer si l\'article peut être livré ou non.',
        submit_order: 'Créer la commande maintenant',
        confirm_submit: 'Confirmer l\'envoi ?',
    },
    page_shopping_payment: {
        title: 'Premier paiement pour les produits',
        des: 'Remarque : cette page ne peut payer que les produits. Les frais d\'expédition sont payés sur la page #Colis Internationaux#.',
        total: 'Total',
        order_no: 'Commande',
        pay_now: 'Aller payer',
        shopping_notice: 'Avis important :',
    },
    page_person: {
        account: 'Compte',
        user_center: 'Centre utilisateur',
        wallet: 'Portefeuille',
        orders: 'Commandes',
        my_order: 'Ma commande',
        my_warehouse: 'En entrepôt',
        my_parcel: 'Colis internationaux',
        address_book: 'Carnet d\'adresses',
        online_store: 'Boutique en ligne',
        my_store: 'Ma boutique',
        activity: 'Activité',
        invite: 'Inviter',
        coupons: 'Coupons',
    },
    page_seller: {
        title: 'Vendeur de confiance',
        buy_hanfu_title: 'Achetez du Hanfu chinois auprès de ces vendeurs, puis nous expédions votre colis',
        buy_sneaker_title: 'Achetez des baskets auprès de ces vendeurs, puis nous expédions votre colis',
        buy_cosplay_title: 'Achetez des produits cosplay auprès de ces vendeurs, puis nous expédions votre colis',
        step_line1: '1. Trouvez des produits auprès de ces vendeurs',
        step_line2: '2. Soumettez la commande d\'achat',
        step_line3: '3. Nous expédions vers vous',
    },
    page_profile: {
        account: 'Compte',
        email: 'E-mail',
        balance: 'Solde',
    },
    page_wallet: {
        top_up: 'Recharger',
        underpaid: 'Sous-payé',
        balance_details: 'Détails du solde',
        time: 'Heure',
        empty: 'Aucun enregistrement',
        amount: 'Montant',
        status: 'Statut',
        info: 'Info',
        pay: 'Payer',
        paid: 'Payé',
        confirm: 'Confirmer',
        discount_info: 'Informations sur la remise',
        and_get: 'et obtenez',
        get_extra: 'supplémentaire',
    },

    "in_warehouse": {
        "packages_in_warehouse": "Colis en entrepôt",
        "product_name": "Nom du produit",
        "please_select": "Veuillez sélectionner",
        "remark": "Remarque",
        "style_sku": "Style/UGS",
        "start_date": "Date de début",
        "end_date": "Date de fin",
        "reset_selections": "Réinitialiser les sélections",
        "select_products_alert": "Sélectionnez les produits à emballer ensemble. Une fois emballés, vous serez informé et pourrez choisir les options d'expédition dans la page « Mes colis ».",
        "estimated_weight": "Poids estimé : {weight} KG",
        "rehearse_parcel": "Simuler le colis",
        "request_packaging": "Demander l'emballage",
        "orders_not_arrived_alert": "Vous avez {count} commandes qui ne sont pas encore arrivées à l'entrepôt. Veuillez confirmer si vous souhaitez emballer maintenant ou attendre tous les articles.",
        "table_empty_text": "Rien sur cette page. Vous pouvez vérifier d'autres pages.",
        "column_image": "Image",
        "column_details": "Détails",
        "order_label": "Commande :",
        "total_label": "Total :",
        "type_label": "Type :",
        "status_label": "Statut :",
        "time_label": "Heure :",
        "style_label": "Style :",
        "quantity_prefix": "x",
        "no_remark": "Pas de remarque",
        "package_info_label": "Infos sur le colis",
        "weight_label": "Poids :",
        "length_label": "Longueur :",
        "width_label": "Largeur :",
        "height_label": "Hauteur :",
        "unit_kg": "KG",
        "unit_cm": "CM",
        "action_label": "Action",
        "view": "Voir",
        "photos": "Photos",
        "cancel": "Annuler",
        "mobile_label_total": "Total :",
        "mobile_label_type": "Type :",
        "mobile_label_name": "Nom :",
        "view_product": "Voir le produit",
        "mobile_style_label": "Style :",
        "no_items_selected": "Aucun article sélectionné",
        "submit_packaging_request": "Envoyer la demande d'emballage",
        "dialog_request_packaging_title": "Demande d'emballage",
        "dialog_request_packaging_info": "Nous emballerons vos articles sélectionnés ensemble. Une fois emballés, vous pourrez consulter les dimensions réelles et choisir les options d'expédition dans « Mes colis ».",
        "packaging_instructions": "Instructions d'emballage",
        "placeholder_packaging_instructions": "Des instructions d'emballage spéciales ou des préoccupations ?",
        "selected_items": "Articles sélectionnés",
        "packaging_note": "Note : Après l'emballage, nous déterminerons les dimensions et le poids exacts de votre colis. Vous pourrez ensuite choisir votre méthode d'expédition et fournir votre adresse dans la section « Mes colis ».",
        "new_packaging_process": "Nouveau processus d'emballage",
        "step_request_packaging": "Demander l'emballage :",
        "step_request_packaging_desc": "Sélectionnez des produits et envoyez la demande d'emballage.",
        "step_warehouse_packaging": "Emballage à l'entrepôt :",
        "step_warehouse_packaging_desc": "Notre personnel emballera vos articles sélectionnés.",
        "step_measurement": "Mesure :",
        "step_measurement_desc": "Nous mesurerons les dimensions et le poids exacts de votre colis.",
        "step_notification": "Notification :",
        "step_notification_desc": "Vous serez informé lorsque votre colis sera prêt.",
        "step_shipping_setup": "Configuration d'expédition :",
        "step_shipping_setup_desc": "Allez dans « Mes colis » pour sélectionner les options d'expédition et entrer votre adresse.",
        "step_make_payment": "Effectuer le paiement :",
        "step_make_payment_desc": "Payez l'expédition en fonction des dimensions et du poids réels du colis.",
        "confirm_packaging_title": "Confirmer la demande d'emballage",
        "confirm_packaging_text": "Vous êtes sur le point de demander l'emballage de {count} article(s). Continuer ?",
        "item_qc_photos": "Photos de contrôle qualité de l'article",
        "empty_qc_desc": "Votre article n'est pas encore arrivé dans notre entrepôt.",
        "return_items_title": "Retourner les articles",
        "return_items_text": "Le retour des articles peut entraîner des frais supplémentaires. Voulez-vous quand même continuer ?",
        "number_of_items_to_return": "Nombre d'articles à retourner :",
        "confirm": "Confirmer",
        column_image: "Image",
    },
    "page_address_book": {
        "title": "Mon Carnet d'Adresses",
        "buttons": {
            "add_new": "Ajouter Nouveau",
            "save": "Enregistrer l'Adresse"
        },
        "dialog": {
            "title": "Ajouter Votre Adresse",
            "alert": "Ajoutez votre adresse pour l’utiliser lors de vos prochaines commandes !",
            "form": {
                "contact_name": "Nom du Contact",
                "address": "Adresse",
                "city": "Ville",
                "province": "État/Province",
                "country": "Pays",
                "country_placeholder": "Sélectionner le Pays de Destination",
                "zip_code": "Code Postal",
                "phone": "Téléphone",
                "email": "Email",
                "email_placeholder": "Recommandé"
            }
        }
    },
    "page_wallet": {
        "header": {
            "title": "Aperçu du Portefeuille",
            "subtitle": "Gérez votre solde et votre historique de transactions"
        },
        "balance_card": {
            "label": "Solde Disponible",
            "currency": "USD",
            "top_up_button": "Recharger le Solde"
        },
        "history": {
            "title": "Historique des Transactions",
            "count": "{count} transactions",
            "empty": {
                "title": "Aucune transaction pour le moment",
                "subtitle": "Votre historique de transactions apparaîtra ici"
            },
            "item": {
                "order_prefix": "Commande :",
                "balance_after_prefix": "Solde :",
                "note_prefix": "Note :",
                "complete_payment_button": "Finaliser le Paiement",
                "mobile": {
                    "order_id_label": "ID Commande :",
                    "balance_after_label": "Solde Après :",
                    "status_label": "Statut :"
                }
            }
        },
        "top_up_dialog": {
            "title": "Rechargement",
            "form": {
                "amount_label": "Saisir le Montant (USD)",
                "quick_select_title": "Montant Sélection Rapide",
                "create_payment_button": "Créer le Paiement"
            }
        }
    },
    "page_message_center": {
        "title": "Centre de Messages",
        "filters": {
            "all": "Tous",
            "unread": "Non lus",
            "read": "Lus",
            "search_placeholder": "Rechercher des messages..."
        },
        "actions": {
            "mark_all_read": "Marquer tout comme lu",
            "delete_all": "Supprimer tous les messages",
            "refresh": "Actualiser les Messages"
        },
        "delete_confirm": {
            "title": "Supprimer ce message ?",
            "confirm_button": "Supprimer",
            "cancel_button": "Annuler"
        },
        "empty_states": {
            "no_search_results": "Aucun message correspondant à votre recherche.",
            "no_unread": "Vous n'avez aucun message non lu.",
            "no_read": "Vous n'avez aucun message lu.",
            "no_messages_yet": "Votre centre de messages est vide."
        }
    },
    "page_user_profile": {
        "tabs": {
            "profile": "Profil",
            "account_safety": "Sécurité du Compte"
        },
        "profile_section": {
            "email": "E-mail :",
            "gender": "Sexe :",
            "country": "Pays :",
            "language": "Langue :",
            "current_language": "Anglais",
            "phone": "Téléphone :",
            "birthday": "Date de Naissance :",
            "vip_prefix": "VIP",
            "max_vip_level": "VIP5",
            "privilege_title": "Mes Privilèges",
            "privilege_table_header": "Niveau de Privilèges"
        },
        "safety_section": {
            "modify_password_title": "Modifier le Mot de Passe",
            "modify_password_desc": "Un mot de passe plus sécurisé protège mieux votre compte. Il est recommandé de le changer régulièrement et d'utiliser des chiffres et des lettres.",
            "modify_password_button": "Modifier le Mot de Passe"
        },
        "update_info_dialog": {
            "title": "Mettre à Jour les Informations du Compte",
            "account_name_label": "Nom du Compte",
            "phone_label": "Numéro de Téléphone",
            "gender_label": "Sexe",
            "gender_placeholder": "Sélectionner",
            "country_label": "Pays",
            "country_placeholder": "Sélectionner un pays",
            "birthday_label": "Date de Naissance",
            "birthday_placeholder": "Sélectionner",
            "save_button": "Enregistrer les Informations"
        },
        "update_password_dialog": {
            "title": "Mettre à Jour le Mot de Passe",
            "old_password_label": "Ancien Mot de Passe",
            "new_password_label": "Nouveau Mot de Passe",
            "confirm_password_label": "Confirmer le Mot de Passe",
            "save_button": "Enregistrer"
        }
    },
    "page_shipping_calculator": {
        "hero": {
            "title": "Votre Agent d'Achat Chinois Ultime"
        },
        "form_card": {
            "title": "Estimation des Frais de Livraison",
            "subtitle": "Saisissez les détails de votre colis ci-dessous pour obtenir les coûts d'expédition précis",
            "country_label": "Pays de Destination",
            "country_placeholder": "Sélectionner un Pays",
            "country_search_placeholder": "Rechercher un pays...",
            "no_countries_for_letter": "Aucun pays ne commence par {letter}.",
            "no_countries_for_search": "Aucun pays trouvé pour \"{query}\".",
            "category_label": "Catégorie de Produit",
            "category_placeholder": "Sélectionner une Catégorie",
            "select_main_category_first": "Sélectionnez d'abord une catégorie principale.",
            "weight_label": "Poids (kg)",
            "length_label": "Longueur (cm)",
            "width_label": "Largeur (cm)",
            "height_label": "Hauteur (cm)",
            "required_label": "Requis",
            "optional_label": "(Optionnel)",
            "optional_placeholder": "Optionnel",
            "calculating_button": "Calcul en cours...",
            "submit_button": "Obtenir les Frais de Livraison"
        },
        "summary": {
            "title": "Résumé de la Demande d'Expédition",
            "sort_by": "Trier par :",
            "sort_price": "Prix",
            "sort_time": "Temps de Transit",
            "destination": "Destination :",
            "weight": "Poids :",
            "dimensions": "Dimensions :",
            "volume": "Volume :",
            "categories": "Catégories :"
        },
        "results": {
            "loading_text": "Calcul des options d'expédition disponibles...",
            "no_options_title": "Aucune Option d'Expédition Disponible",
            "no_options_desc": "Aucune option d'expédition valide trouvée pour les détails saisis et la destination. <br /> Veuillez vérifier les restrictions de poids, de dimensions et de catégorie de produit pour le pays sélectionné.",
            "initial_state_text": "Veuillez saisir les paramètres requis (Pays, Poids) et cliquer sur \"Obtenir les Frais de Livraison\".",
            "all_unavailable_info": "Tous les canaux d'expédition pour cette combinaison sont indisponibles. Voir les détails ci-dessous.",
            "est_transit_time": "Temps de Transit Est.",
            "volume_weight": "Poids Volumétrique",
            "billing_weight": "Poids Facturable",
            "view_details_button": "Voir les Détails",
            "load_more_button": "Charger plus ({count} restants)",
            "unavailable_channels_title": "Canaux d'Expédition Indisponibles ({count})",
            "not_available_badge": "Non Disponible",
            "reason_prefix": "Raison :"
        },
        "details_modal": {
            "overview_title": "Aperçu de l'Expédition",
            "shipping_fee": "Frais de Livraison",
            "description_title": "Description du Service",
            "no_description": "Aucune description disponible.",
            "restrictions_title": "Restrictions de Transport",
            "category_restrictions_title": "Restrictions de Catégorie de Produit",
            "legend_can_send": "Peut Envoyer",
            "legend_cannot_send": "Ne Peut Pas Envoyer",
            "can_send_subheading": "Peut Envoyer :",
            "cannot_send_subheading": "Ne Peut Pas Envoyer :",
            "no_allowed_items": "Aucun article autorisé spécifique n'est listé (suppose que les marchandises générales sont acceptées sauf restriction)",
            "no_prohibited_items": "Aucun article interdit spécifique n'est listé (les interdictions standards du transporteur s'appliquent)",
            "rules_title": "Règles de Transport",
            "weight_restriction_title": "Restriction de Poids",
            "dimension_restriction_title": "Restriction de Dimension",
            "billing_rules_title": "Règles de Facturation",
            "tax_info_title": "Informations Fiscales",
            "additional_fees_title": "Frais Supplémentaires",
            "no_additional_fees": "Non spécifié (des frais de transporteur standards peuvent s'appliquer)",
            "min_label": "Min :",
            "max_label": "Max :",
            "carrier_limit": "Limite du Transporteur",
            "close_button": "Fermer"
        }
    },
    "page_shopping_guide": {
        "header": {
            "title": "Guide d'Achat",
            "description": "Guide pour Acheter sur Taobao, 1688, Weidian et Yupoo pour les Débutants",
            "video_title": "Vidéo du Processus d'Achat"
        },
        "process": {
            "title": "Processus d'Achat",
            "step1": {
                "title": "Étape 1 : Sélectionner le Produit",
                "description": "Trouvez le produit que vous souhaitez sur Taobao.com, 1688.com, Tmall.com ou Weidian."
            },
            "step2": {
                "title": "Étape 2 : Rechercher le Produit",
                "description": "Si vous ne trouvez pas le produit que vous désirez, n'hésitez pas à demander de l'aide à notre service client 24/7. Copiez et collez le lien du produit sur le site NiuNiuBox. Si vous utilisez l'application Taobao, vous pouvez également trouver le lien du produit sur la page de détail du produit Taobao."
            },
            "step3": {
                "title": "Étape 3 : Sélectionner la Taille/Couleur",
                "description": "Confirmez la taille et la couleur du produit dont vous avez besoin sur NiuNiuBox, puis ajoutez-le à votre panier."
            },
            "step4": {
                "title": "Étape 4 : Premier Paiement",
                "description": "Consultez votre panier et effectuez le premier paiement pour les articles que vous avez sélectionnés."
            },
            "step5": {
                "title": "Étape 5 : Soumettre Votre Adresse",
                "description": "Une fois que vous aurez effectué le premier paiement, l'équipe de NiuNiuBox achètera les produits pour vous. Après l'arrivée de tous vos produits à notre entrepôt, vous devrez soumettre votre adresse afin que nous puissions emballer vos articles dans une seule grande boîte."
            },
            "step6": {
                "title": "Étape 6 : Deuxième Paiement",
                "description": "Après avoir emballé vos produits, vous recevrez un e-mail avec le poids du colis et les frais d'expédition. Vous devrez alors payer les frais d'expédition internationaux, et nous expédierons votre colis de notre entrepôt en Chine à votre adresse."
            },
            "step7": {
                "title": "Étape 7 : Attendre Votre Colis",
                "description": "Une fois votre colis expédié, vous recevrez un numéro de suivi dans les 3 jours. Cela vous permettra de voir l'emplacement de votre colis."
            }
        }
    },
    "page_contact_us": {
        "title": "Contactez-nous",
        "support_email_label": "E-mail du Support Client :"
    },
    "page_my_account": {
        "title": "Mon Compte",
        "profile_card": {
            "member_type": "Membre Ordinaire",
            "member_since": "Membre depuis",
            "logout_confirm": "Êtes-vous sûr de vouloir vous déconnecter ?",
            "top_up_button": "Recharger",
            "orders_label": "Commandes",
            "coupons_label": "Coupons"
        },
        "balance_info": {
            "title": "À Propos de Votre Solde",
            "description": "Lorsque vous demandez l'annulation d'une commande, vos fonds restants seront automatiquement transférés sur votre solde.",
            "highlight1": "Continuez vos achats avec votre solde",
            "highlight2": "Contactez le service client pour les remboursements sur votre compte de paiement"
        },
        "quick_actions": {
            "title": "Actions Rapides",
            "shopping_orders": "Commandes d'Achat",
            "in_warehouse": "En Entrepôt",
            "my_rehearsal": "Ma Répétition",
            "my_parcels": "Mes Colis",
            "my_balance": "Mon Solde",
            "messages": "Messages",
            "my_coupons": "Mes Coupons",
            "cancel_order": "Annuler la Commande"
        },
        "recent_orders": {
            "title": "Commandes Récentes",
            "view_all_button": "Voir Tout",
            "header_product": "Produit",
            "header_amount": "Montant",
            "header_date": "Date",
            "header_status": "Statut",
            "header_actions": "Actions",
            "quantity_prefix": "Qté :",
            "details_button": "Détails"
        },
        "invitation": {
            "title": "Inviter des Amis",
            "description": "Partagez notre site avec des amis et gagnez des récompenses :",
            "copy_button": "Copier"
        }
    },
    "page_shopping_order": {
        "title": "Commande d'Achat",
        "search": {
            "order_number_placeholder": "Numéro de Commande",
            "product_name_placeholder": "Nom du Produit",
            "status_placeholder": "Veuillez sélectionner",
            "remark_placeholder": "Remarque",
            "style_sku_placeholder": "Style/SKU",
            "start_date_placeholder": "Date de Début",
            "end_date_placeholder": "Date de Fin",
            "search_button": "Rechercher",
            "pay_button": "Payer les Commandes"
        },
        "info_alert": "Cette page affiche les commandes d'achat comme celles de Taobao/1688/Weidian. Veuillez sélectionner les commandes [En attente de paiement] et payer.",
        "table": {
            "empty_text": "Vous n'avez pas encore de commandes d'achat",
            "header": {
                "image": "Image",
                "details": "Détails",
                "product": "Produit",
                "action": "Action"
            },
            "body": {
                "order_prefix": "Commande :",
                "total_prefix": "Total :",
                "type_prefix": "Type :",
                "status_prefix": "Statut :",
                "time_prefix": "Heure :",
                "style_prefix": "Style :",
                "quantity_prefix": "Quantité :",
                "remark_prefix": "Remarque :",
                "name_prefix": "Nom :"
            },
            "actions": {
                "pay_order": "Payer la Commande",
                "view_order": "Voir la Commande",
                "item_photos": "Photos de l'Article",
                "cancel_item": "Annuler l'Article",
                "view_product": "Voir le Produit"
            }
        },
        "qc_dialog": {
            "title": "Photos QC de l'Article",
            "empty_text": "Votre article n'est pas encore arrivé à notre entrepôt."
        },
        "return_dialog": {
            "title": "Retourner des Articles",
            "confirmation_text": "Le retour d'articles peut entraîner des coûts supplémentaires. Voulez-vous toujours continuer ?",
            "quantity_label": "Nombre d'articles à retourner :",
            "cancel_button": "Annuler",
            "confirm_button": "Confirmer"
        },
        "cancel_dialog": {
            "title": "Annuler la Commande",
            "confirmation_text": "Si vous souhaitez annuler cette commande, vous devrez payer les frais d'expédition. Ces frais seront déduits de votre paiement déjà effectué. Voulez-vous continuer ?",
            "cancel_button": "Annuler",
            "confirm_button": "Confirmer"
        }
    },
    "page_shipping_config": {
        "title": "Configuration d'Expédition",
        "summary": {
            "destination": "Destination :",
            "actual_weight": "Poids Réel du Colis :",
            "est_dimensions": "Dimensions Estimées :",
            "weight_note": "*Le poids estimé du colis est basé sur le poids du produit, et le poids réel sera déterminé après la pesée.",
            "product_types": "Types de Produits",
            "selected_method": "Méthode d'Expédition Sélectionnée :",
            "selected_method_none": "Aucune",
            "est_fee": "Frais Estimés :"
        },
        "status": {
            "loading": "Calcul des options d'expédition disponibles...",
            "no_options": "Aucune option d'expédition n'est disponible pour le poids, les dimensions, les types de produits et le pays actuels. <br />Veuillez consulter les restrictions."
        },
        "options": {
            "select_sr_label": "Sélectionner {channelName}",
            "shipping_fee": "Frais d'Expédition",
            "volume_weight": "Poids Volumétrique",
            "volume_weight_formula": "Poids Volumétrique (KG) = L*l*H (CM) / {denominator}",
            "billing_weight": "Poids Facturable",
            "billing_weight_details": "Basé sur le plus grand entre le poids réel ({weight} kg) et le poids volumétrique. Des arrondis et des minimums peuvent s'appliquer selon les règles du transporteur.",
            "transit_time": "Temps de Transit",
            "hide_details_button": "Masquer les Détails",
            "show_details_button": "Afficher le Détail"
        },
        "details": {
            "category_restrictions_title": "Restrictions de Catégorie de Produit",
            "legend_can_send": "Peut Envoyer",
            "legend_cannot_send": "Ne Peut Pas Envoyer",
            "can_send_subheading": "Peut Envoyer :",
            "no_allowed_items": "Aucun article autorisé spécifique n'est listé (suppose que les marchandises générales sont acceptées sauf restriction)",
            "cannot_send_subheading": "Ne Peut Pas Envoyer :",
            "no_prohibited_items": "Aucun article interdit spécifique n'est listé (les interdictions standards du transporteur s'appliquent)",
            "rules_title": "Règles de Transport",
            "weight_restriction_title": "Restriction de Poids",
            "min_label": "Min :",
            "max_label": "Max :",
            "carrier_limit": "Limite du Transporteur",
            "dimension_restriction_title": "Restriction de Dimension",
            "billing_rules_title": "Règles de Facturation",
            "tax_info_title": "Informations Fiscales",
            "additional_fees_title": "Frais Supplémentaires",
            "no_additional_fees": "Non spécifié (des frais de transporteur standards peuvent s'appliquer)"
        },
        "confirm_button": "Confirmer"
    },
    "page_parcel_details": {
        "loading": "Chargement des détails du colis...",
        "overview": {
            "title": "Aperçu du Colis",
            "parcel_id": "ID du Colis",
            "payment_time": "Date de Paiement",
            "status": "Statut",
            "shipping_cost": "Frais d'Expédition",
            "billing_weight": "Poids Facturable",
            "parcel_remark": "Remarque sur le Colis",
            "your_note": "Votre Note"
        },
        "tracking": {
            "title": "Informations de Suivi",
            "empty_text": "Aucune information de suivi pour le moment. Vous recevrez un numéro de suivi une fois expédié (~3 jours)."
        },
        "items": {
            "title": "Articles du Produit",
            "empty_text": "Aucun article trouvé",
            "header_order_image": "Commande / Image",
            "header_product_details": "Détails du Produit",
            "header_qc_photos": "Photos QC",
            "order_prefix": "Commande :",
            "sku_prefix": "SKU :",
            "quantity_prefix": "Qté :",
            "note_prefix": "Note :"
        }
    },
    "page_parcel_details": {
    "loading": "Chargement des détails du colis...",
    "overview": {
      "title": "Aperçu du Colis",
      "parcel_id": "ID du Colis",
      "payment_time": "Date de Paiement",
      "status": "Statut",
      "shipping_cost": "Frais d'Expédition",
      "billing_weight": "Poids Facturable",
      "parcel_remark": "Remarque sur le Colis",
      "your_note": "Votre Note"
    },
    "tracking": {
      "title": "Informations de Suivi",
      "empty_text": "Aucune information de suivi pour le moment. Vous recevrez un numéro de suivi une fois expédié (~3 jours)."
    },
    "items": {
      "title": "Articles du Produit",
      "empty_text": "Aucun article trouvé",
      "header_order_image": "Commande / Image",
      "header_product_details": "Détails du Produit",
      "header_qc_photos": "Photos QC",
      "order_prefix": "Commande :",
      "sku_prefix": "SKU :",
      "quantity_prefix": "Qté :",
      "note_prefix": "Note :"
    }
  },
  "page_affiliate": {
    "header": {
      "title": "Bonus de 30% Augmenté",
      "description": "Basé sur le Bonus de l'Envoi des Nouvelles Affiliations"
    },
    "commission": {
      "title": "Ma Commission de Promotion",
      "invited_users": "Utilisateurs Invités :",
      "new_affiliates": "Nouveaux Affiliés :",
      "active_users": "Utilisateurs Actifs :"
    },
    "balance": {
      "title": "Mon solde d'affilié",
      "amount_withdrawn": "Montant Retiré :",
      "withdrawn_button": "Retirer",
      "withdrawable_title": "Retirable",
      "board_earnings_title": "Gains de Création de Tableau",
      "claim_button": "Réclamer"
    },
    "steps": {
      "step1": "Partagez les codes d'invitation avec vos amis",
      "step2": "Un ami a passé une commande et a reçu le colis",
      "step3": "Recevez la commission"
    },
    "promotion_method": {
      "title": "Méthode de Promotion",
      "mobile_description": "Description de la Règle Description de la Règle Description de la Règle",
      "desktop_description": "La commission que vous recevez chaque mois sera directement transférée sur votre compte personnel.",
      "invite_link_label": "Lien d'invitation :",
      "copy_link_button": "Copier le Lien",
      "copy_code_button": "Copier le Code d'Invitation",
      "download_qr_button": "Télécharger le Code QR"
    }
  },
   "page_product_details": {
    "promo_banner": "Achetez des produits rentables sur les sites de commerce électronique chinois et économisez plus d'argent. Expédition mondiale depuis la Chine.",
    "stats": {
      "sales": "Ventes :",
      "inventory": "Inventaire :"
    },
    "info": {
      "original_link": "Lien Original",
      "processing_time": "Après le paiement, nous achèterons pour vous dans les 12 heures.",
      "domestic_shipping": "Expédition Nationale",
      "free_shipping": "Livraison Gratuite",
      "shipping_note": "Les frais de port locaux du vendeur à notre entrepôt en Chine."
    },
    "options": {
      "quantity": "Quantité",
      "items_available": "{count} articles disponibles",
      "order_remark": "Remarque sur la commande :",
      "order_remark_subtitle": "Ajoutez des instructions ou des demandes spéciales",
      "remark_placeholder": "Veuillez laisser un message au vendeur, comme la couleur, la taille, etc."
    },
    "actions": {
      "shipping_cost_estimate": "Estimation des Frais de Port",
      "disclaimer_title": "Avis de non-responsabilité",
      "disclaimer_text": "Tous les produits disponibles pour le service d'agent d'achat affichés sur Niuniubox proviennent de plateformes d'achat tierces et ne sont pas vendus directement par Niuniubox. Ainsi, Niuniubox n'assume aucune responsabilité légale pour les problèmes causés par la violation des droits de propriété intellectuelle et des droits d'auteur des marchandises.",
      "agreement_checkbox": "J'ai lu et j'accepte",
      "buy_now": "Acheter Maintenant",
      "add_to_cart": "Ajouter au Panier",
      "share": "Partager"
    },
    "share_dialog": {
      "title": "Partager ce produit",
      "platform_facebook": "Facebook",
      "platform_whatsapp": "WhatsApp",
      "platform_wechat": "WeChat",
      "platform_discord": "Discord",
      "platform_email": "Email",
      "copy_button": "Copier"
    },
    "sidebar": {
      "original_site": "Site original :",
      "why_title": "Pourquoi Taobao, 1688, Weidian, Yupoo, Tmall ?",
      "why_description": "Les produits sur ces plateformes sont très bon marché. Si vous avez besoin de dépenser le moins d'argent possible pour acheter des produits de haute qualité, acheter sur ces plateformes est le plus rentable. Nous fournissons des services de logistique mondiaux par voie aérienne et maritime.",
      "details_title": "Détails du Produit",
      "empty_details": "Détail du Produit Vide."
    },
    "loading": {
      "try_again": "Réessayer",
      "note_title": "Note :",
      "error_note_1": "1. Vous pouvez nous contacter si vous ne voyez pas les informations sur le produit.",
      "error_note_2": "2. Le produit est en rupture de stock ou l'URL du produit est invalide. Veuillez vérifier votre lien de produit.",
      "error_note_3": "3. Plateformes supportées : Taobao.com, 1688.com, Tmall.com, Weidian.com (Supporte uniquement l'URL du produit)"
    }
  },
  "shopping_steps": {
    "title": "Comment Ça Marche",
    "steps_data": [
      {
        "title": "Trouver des Produits",
        "des": "Parcourez des millions de produits sur les marchés chinois comme Taobao, 1688, Weidian, Tmall à des prix de gros"
      },
      {
        "title": "Ajouter au Panier",
        "des": "Sélectionnez vos articles, choisissez les spécifications et ajoutez-les à votre panier pour une gestion facile des commandes"
      },
      {
        "title": "Effectuer le Paiement",
        "des": "Payez vos articles en toute sécurité, et nous les achèterons auprès de différents vendeurs en votre nom"
      },
      {
        "title": "Recevoir la Livraison",
        "des": "Nous expédions votre colis consolidé de la Chine à votre porte avec des informations de suivi complètes"
      }
    ]
  }

}